<template>
  <section>
    <transition name="fade" mode="out-in">
      <router-view :key="$route.fullPath"></router-view>
    </transition>
  </section>
</template>
  
<script>
  export default {
    name: 'AppMain',
    data() {
      return {
      }
    },
    mounted() {
    },
    methods: {
    }
  }
  </script>
  
  <style rel="stylesheet/scss" lang="scss" scoped>
  </style>
  


// WEBPACK FOOTER //
// src/views/Layout/components/AppMain.vue